import React from 'react';
import '../../../styles/components/MyJobsList/MyJobsFooter.scss';
import propTypes from 'prop-types';
import mitraLogo from '../../../assets/mitra-red-logo.png';

function MyJobsFooter(props) {
  const { watchVideo } = props;
  return (
    <div className="my_jobs_footer">
      <img src={mitraLogo} alt="logo" />
      <p>
        Mitra has helped thousands of people to find jobs{' '}
        <strong onClick={watchVideo}> Watch Video</strong>
      </p>
    </div>
  );
}

MyJobsFooter.propTypes = {
  watchVideo: propTypes.func.isRequired,
};

export default MyJobsFooter;
